export default __webpack_public_path__ + "static/media/vizuail_spash.a1717e19.jpeg";